import { Check } from "@phosphor-icons/react";
import {
	ANSWER_SOURCE,
	FIX_TYPE,
	getDisplayableDocuments,
	getDisplayableQuestions,
	getFixTypeFromFixableItems,
	getValidationResult,
	TEDCApplicant,
	useEDCFlow,
	VALIDATION_STATUS
} from "@smvtech/x-flux";
import { useMemo } from "react";
import DocumentListItem from "./DocumentListItem";

type DocumentsListProps = {
	activeApplicantData: TEDCApplicant;
};

const DocumentsList = ({ activeApplicantData }: DocumentsListProps) => {
	const documents = useMemo(
		() =>
			getDisplayableDocuments(activeApplicantData.questions, [ANSWER_SOURCE.USER_INPUT, ANSWER_SOURCE.DOCUMENT]),
		[activeApplicantData.questions]
	);
	const questions = useMemo(
		() => getDisplayableQuestions(activeApplicantData.questions, [ANSWER_SOURCE.PASSPORT_FRONT_OCR]),
		[activeApplicantData.questions]
	);

	const documentsWithValidation = useMemo(() => {
		return documents.map((document) => {
			const validationResult = getValidationResult(document);
			const showVerified =
				validationResult?.status === VALIDATION_STATUS.PERFECT ||
				(validationResult?.status === VALIDATION_STATUS.FIXABLE &&
					getFixTypeFromFixableItems(validationResult.fixable.items) === FIX_TYPE.MANUAL);
			return { document, showVerified };
		});
	}, [documents]);

	return (
		<div className="col-span-3 flex flex-col gap-6">
			{documentsWithValidation.map(({ document, showVerified }, index) => (
				<div key={document.id} className="flex flex-col gap-4">
					<div className="flex items-center justify-between">
						<p className="text-sm text-gray-950">
							{index + 1}. {document.question.question}
						</p>

						{showVerified && (
							<span className="flex items-center gap-2 text-xs text-green-700 bg-green-50 px-1.5 py-[2px] rounded-full">
								<Check size={18} className="min-w-3 max-w-3 text-green-700" />
								Verified
							</span>
						)}
					</div>
					<DocumentListItem
						key={`${activeApplicantData.application_id}-${document.id}`}
						document={document}
						questions={questions}
						activeApplicantData={activeApplicantData}
					/>
				</div>
			))}
		</div>
	);
};

export default DocumentsList;

